export default {
  zbid: 'ZBID',
  vzandesc: 'VZAN_DESC',
  setWxCofig: 'SET_WX_CONFIG',
  zbvd: 'ZBVD',
  userInfo: 'USER_INFO',
  /** 峰会展会 */
  isSignIn: 'isSignIn', // 是否已签到
  isSignUp: 'isSignUp', // 是否已报名
  isUserNoPayment: 'isUserNoPayment', // 是否存在未付款票券
  isTicket: 'isTicket', // 是否需要购票流程
  playbackType: 'playbackType', // 回放类型
  expoActivity: 'expoActivity', // 峰会展会活动详情
  expoHasLive: 'expoHasLive', // 是否有主办方直播进行中
  audioPlaying: 'audioPlaying', // 全局控制多个音频播放开关
  setStoreStyleInfo: 'SET_STORE_STYLE_INFO', // 店铺风格信息
  setMerchantMiniConfig: 'setMerchantMiniConfig', // 商家小程序技术支持文案配置
  setCustomConfig: 'setCustomConfig', // 获取定制直播间配置
  updateOrderFilterParams: 'updateOrderFilterParams', // 订单列表筛选条件
  updateOrderFilterParamsGoodsName: 'updateOrderFilterParamsGoodsName', // 订单列表筛选条件-商品名称
  updateOrderFilterParamsNew: 'updateOrderFilterParamsNew', // 订单列表筛选条件(new)
  updateCouponFilterParams: 'updateCouponFilterParams', // 优惠券统计筛选条件
  updateCouponFilterParamsNew: 'updateCouponFilterParamsNew', // 优惠券统计筛选条件（new)
  updateGoodsFilterParams: 'updateGoodsFilterParams', // 商品统计筛选
  updateGoodsFilterParamsNew: 'updateGoodsFilterParamsNew', // 商品统计筛选（new)
  setAuthDataAndAgentSetting: 'setAuthDataAndAgentSetting', // 代理数据和代理配置
  setPersonalBalance: 'setPersonalBalance', // 个人余额
  setShowedBindStorePopup: 'setShowedBindStorePopup', // 保存门店弹窗弹出过的标识
  setGuokeCustomization: 'setGuokeCustomization', // 是否国科直播间
  setAgentTeamConfig: 'setAgentTeamConfig', // 国科代理团队身份信息
  addCachedComponent: 'addCachedComponent', // 添加缓存路由
  removeCachedComponent: 'removeCachedComponent', // 删除缓存路由
  setAgentAuthList: 'setAgentAuthList', // 添加代理中心权限
  setAgentGray: 'setAgentGray', // 设置代理中心灰度直播间资格
  setIntegral: 'setIntegral', // 设置积分信息
  setSelfVerifyConfig: 'setSelfVerifyConfig', // H5端获取用户自主核销配置
  updateTime: 'UPDATE_TIME', // 设置服务器时间
  startClock: 'START_CLOCK', // 开始计时
  stopClock: 'STOP_CLOCK', // 停止计时
  update_fontsize: 'UPDATE_FONTSIZE', // 更新字体大小
  setSupportFreightInsurance: 'setSupportFreightInsurance', // 设置直播间支持运费险信息
  setIsAgent: 'isAgent',
  setBusinessModel: 'SET_BUSINESS_MODEL', // 个人中心-行业字段（与代理中心不同）
  setFollowInfoCache: 'SET_FOLLOW_INFO_CACHE', // 设置关注信息缓存
  isForBiddenLive: 'IS_FORBIDDEN_LIVE', // 是否为封禁直播间
  setPayThirdType: 'setPayThirdType', // 设置支付第三方类型
  setIsBanShareInline: 'SET_IS_BAN_SHARE_INLINE' // 是否屏蔽H5分享判断条件
}
